import { TextProps } from '@slal/ui/typography';
import { ComponentPropsWithRef } from 'react';
import { StyledFieldHelp } from './styles';

export const FieldHelp = (props: ComponentPropsWithRef<'p'> & TextProps) => <StyledFieldHelp {...props} />;
